import { z } from 'zod'
import { Address, WeiString } from '../primitives.js'
import { AgentActionView } from './mandate.js'
export const PayoutRecipient = z
  .object({ to: Address, amount: WeiString.refine((v) => BigInt(v) > 0n) })
  .strict()
export const CreateAgentPayout = z
  .object({
    token: Address,
    totalAmount: WeiString.refine((v) => BigInt(v) > 0n),
    audience: z.enum(['addresses', 'holders']),
    allocation: z.enum(['equal', 'proportional']),
    recipients: z.array(PayoutRecipient).max(200).optional(),
  })
  .strict()
export const AgentPayout = z.object({
  id: z.string().uuid(),
  strategyId: z.string(),
  wallet: z.string(),
  token: Address,
  totalAmount: WeiString,
  audience: z.enum(['addresses', 'holders']),
  snapshotBlock: z.string().nullable(),
  recipients: z.array(PayoutRecipient),
  expiresAt: z.string(),
  state: z.enum(['draft', 'submitting', 'accepted']),
  /** Each batch of at most 100 recipients as the action it became (lane BOO2), with the platform's receipt. */
  actions: z.array(AgentActionView),
})
export const AgentFunding = z.object({
  strategyId: z.string().nullable(),
  accountId: z.string().nullable(),
  network: z.literal('robinhood'),
  funding: z.literal('support'),
  wallets: z.array(
    z.object({ wallet: z.string(), address: Address, family: z.string() }),
  ),
  ready: z.boolean(),
})
